/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbTaskBody } from './HchbTaskBody';
import {
    HchbTaskBodyFromJSON,
    HchbTaskBodyFromJSONTyped,
    HchbTaskBodyToJSON,
    HchbTaskBodyToJSONTyped,
} from './HchbTaskBody';

/**
 * 
 * @export
 * @interface StartExecutionRequest
 */
export interface StartExecutionRequest {
    /**
     * Facility ID
     * @type {string}
     * @memberof StartExecutionRequest
     */
    facilityId: string;
    /**
     * 
     * @type {HchbTaskBody}
     * @memberof StartExecutionRequest
     */
    taskBody: HchbTaskBody;
    /**
     * HCHB patient request ID
     * @type {string}
     * @memberof StartExecutionRequest
     */
    requestId: string;
    /**
     * Lead ID
     * @type {string}
     * @memberof StartExecutionRequest
     */
    leadId: string;
}

/**
 * Check if a given object implements the StartExecutionRequest interface.
 */
export function instanceOfStartExecutionRequest(value: object): value is StartExecutionRequest {
    if (!('facilityId' in value) || value['facilityId'] === undefined) return false;
    if (!('taskBody' in value) || value['taskBody'] === undefined) return false;
    if (!('requestId' in value) || value['requestId'] === undefined) return false;
    if (!('leadId' in value) || value['leadId'] === undefined) return false;
    return true;
}

export function StartExecutionRequestFromJSON(json: any): StartExecutionRequest {
    return StartExecutionRequestFromJSONTyped(json, false);
}

export function StartExecutionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartExecutionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'facilityId': json['facilityId'],
        'taskBody': HchbTaskBodyFromJSON(json['taskBody']),
        'requestId': json['requestId'],
        'leadId': json['leadId'],
    };
}

export function StartExecutionRequestToJSON(json: any): StartExecutionRequest {
    return StartExecutionRequestToJSONTyped(json, false);
}

export function StartExecutionRequestToJSONTyped(value?: StartExecutionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'facilityId': value['facilityId'],
        'taskBody': HchbTaskBodyToJSON(value['taskBody']),
        'requestId': value['requestId'],
        'leadId': value['leadId'],
    };
}

